import React, { FC, useState } from 'react'
import styled from 'styled-components';
import { ScreeningContainer } from '../tabs/index.styles';
import { useTranslation } from 'react-i18next';
import AllPsdTab from '../psd-tabs/all-psd-tab.component';
import TopTenPsd from '../psd-tabs/top-ten-psd.component';
import PsdTables from '../psd-tabs/psd-tables.component';
import PsdDashboard from '../psd-tabs/psd-dashboard.component';

const PSDContainer = styled(ScreeningContainer)`
  .psd-body {
    background: #fff;
    height: 100%;
  }

  .grid {
    display: grid;
    grid-template-columns: 1fr 1fr 1fr;
    gap: 0.625rem;
    > div {
      max-width: 99%; 
    }
  }
`;

const tabs = ['all', 'top', 'tables', 'dashboard'];

const PSDFullScreen: FC<{ kato: string }> = ({ kato }) => {
  const { t } = useTranslation();

  const [selectedTab, setSelectedTab] = useState<string>(tabs[0]);

  return (
    <PSDContainer>
      <div className="tabs">
        {tabs.map((tab: string) => (
          <div
            key={tab}
            className={selectedTab === tab ? 'tab active' : 'tab'}
            onClick={() => setSelectedTab(tab)}
          >
            {t('psd-page.' + tab)}
          </div>
        ))}
      </div>

      <div className="psd-body">
        {selectedTab === tabs[0] && <AllPsdTab />}
        {selectedTab === tabs[1] && <TopTenPsd />}
        {selectedTab === tabs[2] && <PsdTables />}
        {selectedTab === tabs[3] && <PsdDashboard />}
      </div>

    </PSDContainer>
  )
}

export default PSDFullScreen